/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export class CrossOverLoopAudio {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		public constructor(crossOverDuration:number = 1) {
			this.audioPlayer = AudioPlayer.getInstance();

			this.clipCount = 2;
			this.clipIndex = 0;
			this.clip = null;

			this.isLoaded = false;
			this.isPlaying = false;

			this.crossOverDuration = crossOverDuration;

			this.timeoutId = -1;
			this.volume = 1;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public load(url:string, masterVolume:number = 1):void {
			if (this.isLoaded) return;
			this.isLoaded = true;

			this.clipIds = [];
			for (let i:number = 0; i < this.clipCount; ++i) {
				const id:string = url + '-' + i;
				this.audioPlayer.load(url, masterVolume, id);
				this.clipIds.push(id);
			}
		}

		public play():void {
			if (this.isPlaying) return;
			this.isPlaying = true;

			this.playCurrent();
		}

		public stop():void {
			if (!this.isPlaying) return;
			this.isPlaying = false;

			this.stopCurrent();
		}

		public setVolume(volume:number):void {
			this.volume = volume;

			if (this.clip) {
				this.clip.setVolume(this.volume);
			}
		}

		private playCurrent():void {
			this.clip = this.audioPlayer.getClip(this.clipIds[this.clipIndex]);
			this.clip.setVolume(this.volume);
			this.clip.play(false, true);

			const interval:number = (this.clip.getDuration() - this.crossOverDuration) * 1000;
			this.timeoutId = window.setTimeout(this.timerHandler, interval);
		}

		private stopCurrent():void {
			if (this.timeoutId != -1) {
				window.clearTimeout(this.timeoutId);
				this.timeoutId = -1;
			}

			if (this.clip) {
				this.clip.stop();
				this.clip = null;
			}
		}

		private timerHandler = ():void => {
			if (++this.clipIndex == this.clipCount) this.clipIndex = 0;
			this.playCurrent();
		};





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private audioPlayer:AudioPlayer;
		private volume:number;

		private clipIds:string[];
		private clip:AudioClip;
		private clipIndex:number;
		private clipCount:number;

		private isLoaded:boolean;
		private isPlaying:boolean;

		private crossOverDuration:number;

		private timeoutId:number;
	}
}
